/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CameraScheduleRule { 
    cameraScheduleRuleType?: CameraScheduleRule.CameraScheduleRuleTypeEnum;
    cameraScheduleRuleMainTrigger?: CameraScheduleRule.CameraScheduleRuleMainTriggerEnum;
    mainTriggerValue?: number;
    size?: number;
    pictureInterval?: number;
    startTime?: string;
    endTime?: string;
    onTime?: number;
    cycleTime?: number;
    ruleOnlyValidOnProximityState?: boolean;
    ruleOnlyValidOnNoProximityState?: boolean;
    ruleOnlyValidInsideVirtualFence?: boolean;
    ruleOnlyValidOutsideVirtualFence?: boolean;
    videoRecordMode?: number;
    cameraFormatId?: number;
    ruleOnlyValidVitNotExpelledState?: boolean;
    ruleOnlyValidVitExpelledState?: boolean;
    ruleOnlyValidVitContactState?: boolean;
    ruleOnlyValidVitNoContactState?: boolean;
}
export namespace CameraScheduleRule {
    export const CameraScheduleRuleTypeEnum = {
        Picture: 'PICTURE',
        Video: 'VIDEO'
    } as const;
    export type CameraScheduleRuleTypeEnum = typeof CameraScheduleRuleTypeEnum[keyof typeof CameraScheduleRuleTypeEnum];
    export const CameraScheduleRuleMainTriggerEnum = {
        Gps: 'GPS',
        Timer: 'TIMER',
        Vit: 'VIT',
        ProximityPrelimanary: 'PROXIMITY_PRELIMANARY',
        HighActivity: 'HIGH_ACTIVITY'
    } as const;
    export type CameraScheduleRuleMainTriggerEnum = typeof CameraScheduleRuleMainTriggerEnum[keyof typeof CameraScheduleRuleMainTriggerEnum];
}


export type CameraScheduleRuleTypeEnum = typeof CameraScheduleRule.CameraScheduleRuleTypeEnum[keyof typeof CameraScheduleRule.CameraScheduleRuleTypeEnum];
export type CameraScheduleRuleMainTriggerEnum = typeof CameraScheduleRule.CameraScheduleRuleMainTriggerEnum[keyof typeof CameraScheduleRule.CameraScheduleRuleMainTriggerEnum];
